import { Injectable, inject } from '@angular/core';
import { Actions } from '@ngrx/effects';

@Injectable()
export class PushNotificationEffects {
  private actions$ = inject(Actions);
}
